import clsx from 'clsx';

import { getPlayerName } from '../../utils/misc';
import type { HistoricalData } from '../../utils/types';

import TeamFlag from '@shared/MatchUnit/utils/TeamFlag';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const SinglePlayerCarouselCard = ({
  data: { cardType, cardImg, season, goalScored, topScorers },
  language,
}: {
  data: HistoricalData;
  language: string;
}) => {
  const t = useTranslateFn();

  const name = getPlayerName(topScorers[0], language);

  return (
    <div className={`${styles['ts-historical-carousel__card']} ${styles[cardType]}`}>
      <img src={cardImg} alt={name} />
      <div className={clsx(styles['ts-historical-carousel__card--competition-logo'], styles[`season-${season}`])} />
      <div className={styles['ts-historical-carousel__card--season-year']}>{season}</div>
      <div className={styles['ts-historical-carousel__card--player-info']}>
        {!!topScorers[0]?.team && (
          <TeamFlag className={styles['ts-historical-carousel__card--flag']} team={topScorers[0].team} />
        )}
        <div className={styles['ts-historical-carousel__card--player-name']}>{name}</div>
        <div className={styles['ts-historical-carousel__card--goals']}>
          {goalScored} {t('stats_goals')}
        </div>
      </div>
    </div>
  );
};

export default SinglePlayerCarouselCard;
